// extracted by mini-css-extract-plugin
module.exports = {"SimpleSearchContainer":"DealSearch_SimpleSearchContainer__mQPb6","SearchDetailContainer":"DealSearch_SearchDetailContainer__ARyFp"};